import { apiFetch, apiPost } from "@/utils";


// Récupération des données de monitoring
function monitoringFrs() {
  return apiFetch("fournisseur/monitoring-bdw");
}

// Récupère les fournisseurs
function getFournisseurs() {
  return apiFetch("bdw/fournisseurs");
}

// Récupère les fiches homogénéisées
function getFH() {
  return apiFetch("bdw/fh");
}

// Analyse la validation FH
function analyseValidateFh(fournisseurId, modeleId) {
  return apiFetch("bdw/validate-fh/analyse?fournisseurId=" + fournisseurId + "&modeleId=" + modeleId)
}

// Valide les éléments de la FH et du fournisseur
function validateFh(fournisseurId, modeleId) {
  return apiPost("bdw/validate-fh/validate?fournisseurId=" + fournisseurId + "&modeleId=" + modeleId)
}

// Recherche par ID FDES
function getFdesArticles(id) {
  return apiFetch(`bdw/fdes?idFdes=${id}`);
}

export default { monitoringFrs, getFournisseurs, getFH, analyseValidateFh, validateFh, getFdesArticles }
export { monitoringFrs, getFournisseurs, getFH, analyseValidateFh, validateFh, getFdesArticles }



// WEBPACK FOOTER //
// ./src/utils/bdoublewin.js